<div class="main-container">
  <mat-toolbar class="setup-password-header">
    <img [src]="logo" alt="logo" class="logo"/>
    <div fxFlex=""></div>
  </mat-toolbar>
  <div class="content-container" fxLayoutAlign="center center">
    <div *ngIf="loading">
      <div id="default-load" class="loading-icon-bubbles">Loading...</div>
    </div>
    <app-change-password [forgotPasswordUserName]="username" [brand]="brand" class="setup-password-container" *ngIf="!loading"></app-change-password>
  </div>
  <footer fxLayout="column">
    <mat-divider></mat-divider>
    <div fxLayout="row"><span fxFlex=""></span><p>{{footer}}</p><span fxFlex=""></span></div>
  </footer>
</div>


